enum ViewType {
  Delivery = 'Delivery',
  Attribution = 'Attribution',
}

export default ViewType;
